import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getImCaseType = () => {
  return httpClientImmigration.get(server.IM_CASE_TYPE);
};

export const getImCaseTypeByCompany = (query) => {
  return httpClientImmigration.get(
    server.IM_CASE_TYPE + `/getbycompany`,
    query,
  );
};

export const getImCaseTypeByDep = (dep_id) => {
  return httpClientImmigration.get(
    server.IM_CASE_TYPE + `/get-by-dep_id/${dep_id}`,
  );
};

export const getImCaseTypeByID = (id) => {
  return httpClientImmigration.get(
    server.IM_CASE_TYPE + `/get-by-id/${id}`,
  );
};

export const addImCaseType = (data) => {
  return httpClientImmigration.post(server.IM_CASE_TYPE, data);
};

export const UpdateImCaseType = (id, data) => {
  return httpClientImmigration.put(
    server.IM_CASE_TYPE + `/${id}`,
    data,
  );
};

export const DeleteImCaseType = (id) => {
  return httpClientImmigration.delete(
    server.IM_CASE_TYPE + `/${id}`,
  );
};

export const getImCaseTypeByCompany_Dep = (query) => {
  return httpClientImmigration.get(
    server.IM_CASE_TYPE + `/getbycompanyanddepartment`,
    query,
  );
};

export const getImCaseTypeByCompany_Dep_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  department_id,
  search,
) => {
  return httpClientImmigration.get(
    server.IM_CASE_TYPE + `/getbycompanyanddepartmentpagination`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id,
        search,
      },
    },
  );
};
